import { useState, useEffect, useContext, useCallback } from "react"
import classes from './Layout.module.scss'
import Navbar from "../NavHeader/Navbar/Navbar"
import MobileNav from "../NavHeader/MobileNav/MobileNav"
import SideDrawer from "../NavHeader/SideDrawer/SideDrawer"
import Footer from "../Footer/Footer"
import AuthContext from "../../store/auth-context";
import { useNavigate } from "react-router-dom";
import { useColorMode } from "@chakra-ui/react";
import { CustomProvider } from "rsuite";
import { getNotifications, updateNotifications } from "../../services";

const Layout = (props) => {
    let navigate = useNavigate();
    // rsuite (the Inspections / Purchases date pickers) has its own dark theme,
    // switched by a class it puts on <body>; without this it stayed light.
    const { colorMode } = useColorMode();
    const authCtx = useContext(AuthContext);
    const isLoggedIn = authCtx.isLoggedIn;
  
    useEffect(() => {
        if (!isLoggedIn){
           navigate("/");
        }
     },[isLoggedIn, navigate]);

    const [showSideDrawer, setShowSideDrawer] = useState(false);
    const [notifications, setNotifications] = useState([]);

    const sideDrawerClosedHandler = () => {
        setShowSideDrawer(false);
    }

    const sideDrawerToggleHandler = () => {
        setShowSideDrawer(currentState => !currentState);
    }

    const handleNotificationClick = (notification) => {
        let id = notification._id;
        setNotifications(prev => 
            prev.map(notif => 
                notif._id === id ? { ...notif, isRead: true } : notif
            )
        );
        updateNotifications({notificationId:id}).then((res) => {
            if (res?.message === "Notification updated successfully") {
                console.log("Notification updated");
            } else {
                console.log("Notification not updated");
            }
        });
        navigate(notification.link);
    };
 
    const handleMarkAllRead = () => {
        setNotifications(prev => 
            prev.map(notif => ({ ...notif, isRead: true }))
        );
        updateNotifications({notificationId:"all"}).then((res) => {
            if (res?.message === "Notification updated successfully") {
                console.log("Notification updated");
            } else {
                console.log("Notification not updated");
            }
        });
    };

    const fetchNotifications = useCallback(() => {
        getNotifications().then((res) => {
            if (res?.message === "Notifications Found") {
                setNotifications(res?.data.reverse());
                
            }
        });
    }, []);

    useEffect(() => {
        if(isLoggedIn) {
            fetchNotifications();
        }
    }, [fetchNotifications, isLoggedIn]);
  
return (
        <CustomProvider theme={colorMode === "dark" ? "dark" : "light"}>
        <div className={classes.layoutContainer}>
            <div className={classes.DesktopOnly}>
                <Navbar 
                    notifications={notifications}
                    onNotificationClick={handleNotificationClick}
                    onMarkAllRead={handleMarkAllRead}
                />
            </div>
            <div className={classes.MobileOnly}>
                <MobileNav 
                    sideDrawerToggleHandler={sideDrawerToggleHandler} 
                    showSideDrawer={showSideDrawer}
                    notifications={notifications}
                    onNotificationClick={handleNotificationClick}
                    onMarkAllRead={handleMarkAllRead}
                />
            </div>
            <SideDrawer open={showSideDrawer} closed={sideDrawerClosedHandler}/>
            {props.children}
            <Footer />
        </div>
        </CustomProvider>
    )
}

export default Layout;